<div
  class="custom-shadow rounded-lg bg-white p-5 transition-all duration-300 ease-in-out 2xl:my-0 2xl:p-4"
>
  <div class="flex items-center justify-between">
    <div class="flex items-center space-x-2">
      <img
        src="assets/icons/chevron-right-icon-blue.svg"
        alt="chevron blue"
        width="16"
        height="16"
      />
      <h3 class="font-montserratBold text-lg text-primary-normal">
        Recibo No. {{ receipt.receipt }}
      </h3>
    </div>
    <a
      class="flex items-center justify-center rounded-[5px] bg-secondary-normal p-2.5"
      [href]="receipt.url"
      target="_blank"
      (click)="clickDownloadReceipt()"
    >
      <img
        src="assets/icons/download-icon.svg"
        alt="download white"
        width="16"
        height="16"
        class="object-cover"
      />
    </a>
  </div>

  <div class="mt-5 grid grid-cols-1 gap-3 md:grid-cols-3">
    <p
      class="flex flex-col gap-2 rounded-lg bg-light-gray px-4 py-3 text-base text-primary-normal"
    >
      <span class="font-freightSansProBook text-[15px]"
        >Cantidad de pólizas pagadas</span
      >
      <span class="font-montserratBold text-sm">{{ numberOfReceipts }}</span>
    </p>

    <p
      class="flex flex-col gap-2 rounded-lg bg-light-gray px-4 py-3 text-base text-primary-normal"
    >
      <span class="font-freightSansProBook text-[15px]">Fecha del recibo</span>
      <span class="font-montserratBold text-sm">{{
        receipt.dateReceipts | date: "dd/MM/yyyy"
      }}</span>
    </p>
    <p
      class="flex flex-col gap-2 rounded-lg bg-light-gray px-4 py-3 text-base text-primary-normal"
    >
      <span class="font-freightSansProBook text-[15px]">Monto pagado</span>
      <span class="font-montserratBold text-sm">{{
        receipt.totalPaid | customCurrency
      }}</span>
    </p>
  </div>
</div>
